/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BatchDeleteBehaviorsModel } from '../../models/batch-delete-behaviors-model';

export interface MarkMultiplePatientBehaviorsAsDeleted$Params {
      body?: BatchDeleteBehaviorsModel
}

export function MarkMultiplePatientBehaviorsAsDeleted(http: HttpClient, rootUrl: string, params?: MarkMultiplePatientBehaviorsAsDeleted$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, MarkMultiplePatientBehaviorsAsDeleted.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

MarkMultiplePatientBehaviorsAsDeleted.PATH = '/api/Staff/MarkMultiplePatientBehaviorsAsDeleted';
